import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { LeapmotorUserAdminDTO, LeapmotorUserDTO } from '../models/user-dto';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';


@Injectable({
  providedIn: 'root'
})

export class UserService {

  private pathAPI = environment.urlAPI;
  private controller = "LeapmotorUser/";

  public userData = new BehaviorSubject<LeapmotorUserDTO>(null);

  constructor(private http: HttpClient) { }

  public initializeUserData() {
    const that = this;
    this.getUserInfo().subscribe(resp => {
      that.setUserData(resp);
    });

  }

  public getUserInfo(): Observable<LeapmotorUserDTO> {
    return this.http.get<LeapmotorUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  setUserData(user: LeapmotorUserDTO) {
    this.userData.next(user);
  }

  getUserData(): Observable<LeapmotorUserDTO> {

    if (this.userData.value != null) {
      return this.userData.asObservable();
    }
    else {
      return this.getUserInfo().pipe(map((userData) => {
        this.userData.next(userData);
        return userData;
      }),
        catchError((err) => {
          return this.userData.asObservable();
        }));
    }
  }

  public get(id: string): Observable<LeapmotorUserAdminDTO> {
    return this.http.get<LeapmotorUserAdminDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: LeapmotorUserAdminDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: LeapmotorUserAdminDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

}